import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import Icon from '../../../components/AppIcon';

const RevenueAttribution = ({ data = [] }) => {
  const chartData = data?.map(item => ({
    name: item?.source?.replace(/_/g, ' ')?.replace(/\b\w/g, c => c?.toUpperCase()),
    revenue: item?.revenue || 0,
    leads: item?.leads || 0,
    converted: item?.converted || 0
  }));

  return (
    <div className="space-y-6">
      {chartData?.length === 0 ? (
        <div className="bg-card border border-border rounded-lg p-12 text-center">
          <Icon name="PieChart" size={48} className="text-muted-foreground mx-auto mb-4 opacity-40" />
          <p className="text-muted-foreground">No revenue attribution data available yet</p>
        </div>
      ) : (
        <div className="bg-card border border-border rounded-lg p-6 shadow-elevation-1">
          <h3 className="text-lg font-semibold text-foreground mb-4">Revenue by Source</h3>
          <ResponsiveContainer width="100%" height={300}>
            <BarChart data={chartData}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" fontSize={12} />
              <YAxis fontSize={12} />
              <Tooltip formatter={(value, name) => [name === 'revenue' ? `$${value}` : value, name]} />
              <Bar dataKey="revenue" fill="#10b981" name="Revenue" radius={[4, 4, 0, 0]} />
              <Bar dataKey="leads" fill="#3b82f6" name="Leads" radius={[4, 4, 0, 0]} />
            </BarChart>
          </ResponsiveContainer>
        </div>
      )}
    </div>
  );
};

export default RevenueAttribution;